import * as React from "react";
import classNames from "classnames";
import {twMerge} from "tailwind-merge";
import {IconButton} from "../IconButton";

export interface NavbarProps extends React.HTMLAttributes<HTMLDivElement> {
  isHome: boolean;
  onBackIconClick?: () => void;
  onHomeIconClick: () => void;
}
type DivComponentProps = React.ComponentProps<"div">;
type ButtonComponentProps = React.ComponentProps<"button">;

const NavbarContext = React.createContext({} as NavbarProps);
const iconPath = {
  back: [
    "M3280 4318 c-28 -7 -206 -181 -847 -821 -447 -446 -820 -827 -829 -845 -24 -50 -28 -97 -14 -149 12 -45 65 -100 819 -856 443 -444 820 -817 837 -828 98 -61 239 -17 295 92 24 47 25 137 3 182 -9 18 -310 327 -670 687 -454 455 -658 666 -669 692 -19 48 -19 128 0 176 11 26 215 237 669 692 360 360 661 669 670 687 22 45 21 135 -3 182 -50 97 -153 140 -261 109z",
  ],
  menu: [
    "M590 4261 c-104 -32 -160 -106 -160 -211 0 -84 53 -161 132 -194 33 -14 197 -16 1465 -16 l1428 0 52 25 c39 18 60 36 82 71 58 90 50 183 -21 260 -73 79 34 74 -1547 73 -773 0 -1417 -4 -1431 -8z",
    "M539 2747 c-24 -13 -57 -43 -74 -66 -27 -39 -30 -50 -30 -120 0 -68 3 -82 27 -117 15 -21 44 -50 65 -64 l37 -25 1996 0 1996 0 37 25 c21 14 50 43 65 64 24 35 27 49 27 116 0 67 -3 81 -27 116 -15 21 -44 50 -65 64 l-37 25 -1986 3 -1987 2 -44 -23z",
    "M566 1265 c-87 -31 -142 -121 -134 -219 6 -70 42 -126 105 -163 l48 -28 1015 0 1015 0 48 28 c126 74 144 244 37 341 -21 19 -56 39 -77 45 -26 7 -360 11 -1028 11 -816 -1 -997 -3 -1029 -15z",
  ],
};

export const LeftActionIcon = ({...restProps}: ButtonComponentProps) => {
  const {isHome, onHomeIconClick, onBackIconClick} =
    React.useContext(NavbarContext);

  const handleGoBack = () => {
    if (onBackIconClick) {
      onBackIconClick();
      return;
    }
    window.history.go(-1);
  };

  return (
    <IconButton
      {...restProps}
      className={twMerge(
        "hover:shadow-none text-primary-700",
        restProps.className,
      )}
      onClick={isHome ? onHomeIconClick : handleGoBack}
      color="light"
      id=""
      path={isHome ? iconPath.menu : iconPath.back}
    />
  );
};

export const Title = ({children, ...restProps}: DivComponentProps) => {
  return (
    <div
      {...restProps}
      className={twMerge(
        "flex justify-center items-center flex-1 text-2xl text-gray-900",
        restProps.className,
      )}
    >
      {children}
    </div>
  );
};

export const Navbar = ({
  children,
  className,
  isHome,
  onBackIconClick,
  onHomeIconClick,
  ...restProps
}: NavbarProps) => {
  return (
    <NavbarContext.Provider value={{isHome, onHomeIconClick, onBackIconClick}}>
      <div
        className={twMerge(
          classNames(
            "flex gap-2 bg-white shadow-md fixed left-0 top-0 right-0 px-2 py-4",
            className,
          ),
        )}
        {...restProps}
      >
        {children}
      </div>
    </NavbarContext.Provider>
  );
};
